import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { environment } from '../../environments/environment';
import { Clientes } from '../cliente';
import { ClienteService } from '../cliente.service';
import { ComprasService } from '../compras.service';
import { Comprobante } from '../comprobante';
import { ComprobanteService } from '../comprobante.service';
import { Emisor } from '../emisor';
import { EmisorService } from '../emisor.service';
import { Factura } from '../Factura';
import { FacturaService } from '../factura.service';
import { FacturaDetalle } from '../FacturaDetalle';
import { FormaPagoService } from '../forma-pago.service';
import { formaPago } from '../formaPago';
import { Inventario } from '../inventario';
import { Producto } from '../producto';
import { ProductoService } from '../producto.service';
import { ProductoPrecio } from '../productoPrecio';
import { UnidadService } from '../unidad.service';
import { Unidades } from '../unidades';
import { Caja } from '../caja';
import { cajaDetalle } from '../cajaDetalle';
import { Peso } from '../peso';
import { CajaService } from '../caja.service';
import Swal from 'sweetalert2';
import { ventasDia } from '../ventasDia';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrupoProductoService } from '../grupoProducto.service';
import { grupoProducto } from '../grupoProducto';
import { element } from 'protractor';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-factura-touch',
  templateUrl: './factura-touch.component.html',
  styleUrls: ['./factura-touch.component.css']
})
export class FacturaTouchComponent implements OnInit {

  //Cierre de Caja 
  @ViewChild('miEfectivo') miEfectivo!: ElementRef;
  @ViewChild('contentCierre') cierreCaja: TemplateRef<any>;
  @ViewChild('caja', { static: true }) cajaContext: TemplateRef<any>;


  keyboardLayout = 'numeric'; // Puede ser 'alphanumeric', 'alpha', 'numeric' o un layout personalizado

  un_centavo: number;
  isRecibo: boolean = true;
  inputValue: string = '';
  total_centavos: number
  cinco_centavo: number;
  diez_centavo: number;
  veinticion_centavo: number;
  cincuenta_centavo: number;
  un_dolar: number;
  billete_uno: number;
  billete_cinco: number;
  billete_diez: number;
  billete_veinte: number;
  billete_cincuenta: number;
  billete_cien: number;
  @Output() keyPress = new EventEmitter<string>();
  @ViewChild('miDiv') miDiv!: ElementRef<HTMLDivElement>;
  total_apertura: number;
  total_caja: number;
  total_billete_uno: number;
  total_billete_cinco: number;
  total_billete_diez: number;
  total_billete_veinte: number;
  total_billete_cincuenta: number;
  total_billete_cien: number;
  total_tarjeta: number;
  caja: Caja;
  cajaDetalle: cajaDetalle;
  total_un_dolar: number;
  gastos: number;
  gastosTotal: number;
  valorApertura: number
  sobrante: number
  sobranteTotal: number;

  total_veinticion_centavo: number;
  total_cincuenta_centavo: number;
  total_diez_centavo: number;
  total_cinco_centavo: number;
  total_centavos_centavos: number
  veiniticion_centavo: number;
  cajas: Caja[] = [];
  moneda_un_dolar: number;
  listaCajaAperturada: Caja[] = [];
  chunkedKeys: string[][];
  keys: string[]
  btnCerra: boolean = false;

  productos: Producto[] = [];
  productosTodos: Producto[] = [];
  productosCategoriaColores: Producto[] = [];
  listaCajaCerrada: Caja[] = [];
  previous: any = [];
  previousCliente: any = [];
  selectedRowIndex: number;
  url: string = '';
  resul: boolean;
  urlImagen: SafeUrl | null = null;
  editForm: FormGroup;
  clienteActual: Clientes;
  clientes: Clientes[];
  clienteNuevo: Clientes;
  productoSelecionado: Producto;
  formaPago: string;
  listCliene: Clientes[];
  formaPagoList: formaPago[];
  factura: Factura;
  emisor: Emisor;
  listaClientesActulizar: Clientes[] = [];
  listaProductos: Producto[] = [];
  listaUnidad: Unidades[] = [];
  listaProductosEspera: Producto[] = [];
  listaBuscarProducto: Producto[] = [];
  subTotal: number;
  descTotal: number;
  iva: number;
  total: number;
  cerrar: boolean

  blod: Blob;
  ruc: string;
  porcentajeIva: number;
  pvpPrecio: number;
  efectivo: number;
  tarjeta: number;
  cambio: number;
  unidadSelect: number;
  codigLector: string;
  tipoCompra: string;
  selectUnidad: string;
  numeroDocumento: string;
  comprobante: Comprobante[];
  facturas: Factura[] = [];
  facturasRespuesta: Factura[] = [];
  facturaDetalles: FacturaDetalle[] = [];
  ventasDia: ventasDia[] = [];
  facturaDetalle: FacturaDetalle;
  total_efectivo: number;
  total_credito: number;
  total_Ventas_Gastos: number;
  total_transferencia: number;
  fecha: Date;
  index: number;
  desabilitar: boolean;
  btnPagar: boolean = false;
  pesoCantidad: string;
  codigoProducto: string;
  unidades: Unidades[];
  searchText: string
  unidadesVenta: Unidades[] = [];
  reportServer: string = 'http://myreportserver/reportserver';
  reportUrl: string = 'MyReports/SampleReport';
  showParameters: string = "true";
  nombreProductoUnidad: string;
  parameters: any = {
    "SampleStringParameter": null,
    "SampleBooleanParameter": false,
    "SampleDateTimeParameter": "9/1/2017",
    "SampleIntParameter": 1,
    "SampleFloatParameter": "123.1234",
    "SampleMultipleStringParameter": ["Parameter1", "Parameter2"]
  };
  language: string = "en-us";
  width: number = 100;
  height: number = 100;
  toolbar: string = "true";
  inventario: Inventario;

  friends = [
    { name: 'John', age: 25 },
    { name: 'Mary', age: 40 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 },
    { name: 'John', age: 25 },
    { name: 'Mary', age: 40 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 },
    { name: 'Peter', age: 85 }
  ];

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective, { static: true }) tableClientes: MdbTableDirective;


  @ViewChild('processingModal') public mdbModal: ModalDirective;
  @ViewChild('modalPrecios') public modalPrecios: ModalDirective;

  @ViewChild("formaPagoModal") public lgFormaPago: ModalDirective;
  @ViewChild("UnidadesModal") public lgUnidadModal: ModalDirective;

  @ViewChild("DetalleModal") public detalleVentas: ModalDirective;


  @ViewChild('component2') content: ElementRef;
  @ViewChild("ClienesModal") public lgCliente: ModalDirective;
  groupedItems: { [key: string]: any[] } = {};
  scannedCode: string = '';
  private isScanning: boolean = false;
  private scanTimeout: any;
  grupos: grupoProducto[];
  ProductoPrecioxUnidades: ProductoPrecio[];
  gruposLista: grupoProducto[];
  mostrarTotal: boolean = false;

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // Iniciar captura de código de barras
    if (!this.isScanning && event.key != 'KeyP') {
      this.isScanning = true;
      this.scannedCode = '';
    }

    clearTimeout(this.scanTimeout);
    this.scanTimeout = setTimeout(() => {
      this.isScanning = false;
      if (this.scannedCode) {
        //    this.buscarProducto(this.scannedCode);
      }
    }, 700); // Se asume que el código de barras será escaneado en menos de 100ms entre caracteres.

    if (event.key === 'Enter') {
      console.log(`Código completo escaneado: ${this.scannedCode}`);
      if (this.scannedCode && this.scannedCode.trim() !== '') {
        this.buscarProducto(this.scannedCode);
        this.scannedCode = ''; // Limpiar el código para el siguiente escaneo
      }
    } else if (event.key !== 'Shift' && event.key !== 'Tab' && event.key !== 'Control' && event.key !== 'Alt' && event.key !== 'CapsLock') {
      this.scannedCode += event.key;
      console.log(`Código escaneado parcial: ${this.scannedCode}`);
    }
    console.log(`Tecla presionada: ${event.key}, scannedCode actual: ${this.scannedCode}`);

  }


  constructor(
    private apiGrupo: GrupoProductoService,
    private sanitizer: DomSanitizer,
    private apiForma: FormaPagoService,
    private apiCompras: ComprasService,
    private apiEmisor: EmisorService,
    private apiProducto: ProductoService,
    private apiCaja: CajaService,
    private api: ClienteService,
    private apiFac: FacturaService,
    private ruter: Router,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private cdRef: ChangeDetectorRef,
    private apiUnidad: UnidadService,
    private apiCompobante: ComprobanteService,
    private cajaServicio: CajaService,
    private router: Router,
    private modalService: NgbModal,
  ) {

    if (localStorage.getItem('cierre_caja') == 'L') {
      this.keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', '←', 'Limpiar', 'Cliente', 'Buscar', 'Cobrar', 'Gaveta', 'Espera', 'Recupera', 'Cerrar', 'Cancelar', 'Revisar'];
      this.cerrar = true
    } else {
      //   this.keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', '←', 'Limpiar', 'Cliente', 'Buscar', 'Cobrar', 'Gaveta', 'Espera', 'Recupera', 'Cerrar'];
      this.keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '.', '←', 'Limpiar', 'Cliente', 'Buscar', 'Cobrar', 'Gaveta', 'Espera', 'Recupera', 'Cerrar', 'Cancelar', 'Revisar'];

      this.cerrar = false
    }
    this.chunkedKeys = this.chunkArray(this.keys, 3);
  }

  searchCliente: string = '';

  chunkArray(array: string[], chunkSize: number): string[][] {
    const results: string[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      results.push(array.slice(i, i + chunkSize));
    }
    return results;
  }


  obtenerColor(key: string): string {
    switch (key) {
      case 'Cobrar': return '#81C784';      // Verde pastel
      case 'Cancelar': return '#E57373';    // Rojo pastel
      case 'Limpiar': return '#FFF176';     // Amarillo pastel

      case 'Cliente': return '#64B5F6';     // Azul pastel
      case 'Gaveta': return '#4DB6AC';      // Verde agua pastel

      case 'Espera': return '#FFB74D';      // Naranja pastel
      case 'Buscar': return '#9575CD';      // Morado pastel
      case 'Recupera': return '#4FC3F7';    // Azul agua pastel
      case 'Cerrar': return '#90A4AE';      // Azul grisáceo
      case 'Revisar': return '#B39DDB';     // Lila pastel

      default: return '#CFD8DC';            // Gris pastel
    }
  }


  /*
  ngOnInit(): void {
    this.listarProducto();
    this.clienteActual= new Clientes();
    this.emisor=new Emisor();
    this.porcentajeIva = 0.0;
    this.subTotal=0.0;
    this.descTotal=0.0;
    this.iva=0.0;
    this.total=0.0;
this.efectivo=0.0;
this.tarjeta=0.0;
this.cambio=0.0;
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ["", Validators.required],
      //codigoProducto: ["", Validators.required],
      producto: ["", Validators.required],
    });


    
 
    this.listarProveedor();
    this.listarProductoParaBuscar();
    this.listarFormaPago();
    this.tipoCompra='R'
    this.apiEmisor.getEmisor(localStorage.getItem('id')).subscribe(( data: Emisor[])=>{
      console.log(data);
      data.forEach(item => {
        this.emisor=item;
        console.log(this.emisor);
      });
      
    });
    this.onChangeCompra(this.tipoCompra);

  } */

  ngOnInit() {
    this.limpiarCierre();
    this.validarAperturaCaja();
    this.listarUnidadesVenta();
    let varInventario = localStorage.getItem('inventario')
    if ('N' !== varInventario)
      this.desabilitar = false;
    else
      this.desabilitar = true;

    if (Number.parseInt(localStorage.getItem("id")) == 8907 ||
      Number.parseInt(localStorage.getItem("id")) == 9002) {
      this.mostrarTotal = false;
    } else {
      this.mostrarTotal = true;
    }
    this.cargarEmisor();


  }



  ngOnInit_rapido() {
    this.limpiarCierre();
    //this.validarAperturaCaja();
    //this.listarUnidadesVenta();
    let varInventario = localStorage.getItem('inventario')
    if ('N' !== varInventario)
      this.desabilitar = false;
    else
      this.desabilitar = true;


  }


  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) :
      value;
  }




  selectRow(index: number) {
    this.selectedRowIndex = index;
    this.inputValue = ''
    //alert(index)
  }


  cancelar() {
    this.listaProductos = [];
    this.iniciarFacturacion();
    this.ngOnInit_rapido();


  }

  revisar() {

    this.detalleVentas.show();

  }
  onKeyPress(key: string, event: KeyboardEvent) {
    this.miDiv.nativeElement.focus();
    if (key === 'Cliente') {
      this.agregarCliente();
    } else if (key === '←') {
      this.inputValue = this.inputValue.slice(0, -1);

    } else if (key === 'Cobrar') {
      this.cobrar();
    } else if (key === 'Cancelar') {
      this.cancelar();
    } else if (key === 'Revisar') {
      this.revisar();
    } else if (key === 'Buscar') {
      this.cargarClientes()
    } else if (key === 'Gaveta') {
      this.abrirGaveta();

    } else if (key === 'Cerrar') {
      this.cierre(this.cajaContext)

    } else if (key === 'Espera') {
      if (this.listaProductos.length > 0) {
        this.listaProductosEspera = this.listaProductos;
        this.listaProductos = [];
        this.calcular();
      }

    } else if (key === 'Recupera') {
      if (this.listaProductosEspera.length > 0) {
        this.listaProductos = this.listaProductosEspera;
        this.listaProductosEspera = [];
        this.calcular();
      }

    } else if (key === 'Limpiar') {
      this.inputValue = '0';
      this.limpiarBoton();
      this.calcular();
    } else {
      this.inputValue = this.inputValue + key;

    }
    if (this.validarNumeros(this.inputValue)) {
      if (this.listaProductos.length >= 0) {
        let lista = this.listaProductos.filter(a => a.ordenar === this.selectedRowIndex)
        lista[0].cantidad = parseFloat(this.inputValue)
        let entidadV = lista[0]
        this.valueChangeCantidad(entidadV)
      }
    }

  }


  onToggle() {
    const tipo = this.isRecibo ? 'R' : 'F';
    this.tipoCompra=tipo;
    this.onChangeCompra(tipo);
  }

  /*onChangeCompra(newValue) {


    if (newValue == 'F') {
      this.porcentajeIva = this.emisor.iva;
    } else {
      this.porcentajeIva = 0.0;
    }

    this.calcular()
    
    this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'), newValue)
      .subscribe((
        data: Comprobante[]) => {
        this.comprobante = data;
        this.comprobante.forEach(element => {
          this.numeroDocumento = this.PadLeft(element.secuencial, 9);

        }
      
      );
      
      }
        , err => {
          console.log(err);

        });

  }*/


  onChangeCompra(newValue) {
    if (newValue == 'F') {
      this.porcentajeIva = this.emisor.iva;
    } else {
      this.porcentajeIva = 0.0;
    }
    this.apiCompobante.secuenciaComprobante(localStorage.getItem('id'), newValue)
      .subscribe((
        data: Comprobante[]) => {
        this.comprobante = data;
        this.comprobante.forEach(element => {
          this.numeroDocumento = this.PadLeft(element.secuencial, 9);
          this.calcularTotales();
        });
        this.listaProductos.forEach(element => {
          this.RecaculcularIvaPorItem(element.idUnidad, element,this.emisor,newValue);
        });

      }
        , err => {
          console.log(err);

        });

  }




  calcularTotales() {
    this.subTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    this.descTotal = 0.0;
    let valorDes = 0;
    this.listaProductos.forEach((item) => {
      if (item.iva == "N") {
        item.valorIva = item.total * 0;
      } else {
        //if (this.tipoCompra=='F')
        item.valorIva = item.total * this.porcentajeIva;

      }
      this.subTotal = this.subTotal + item.total;
      this.iva = this.iva + item.valorIva;

    });

    this.listaProductos.forEach((item) => {
      this.descTotal = this.descTotal + item.valdesc;
    });
    //this.iva = this.subTotal * this.porcentajeIva;
    this.total = this.subTotal + this.iva;
  }


  limpiarCierre() {
    this.total_efectivo = 0;
    this.total_caja = 0;
    this.un_centavo = 0;
    this.cinco_centavo = 0;
    this.diez_centavo = 0;
    this.gastos = 0;
    this.gastosTotal = 0;
    this.valorApertura = 0;
    this.veinticion_centavo = 0;
    this.un_dolar = 0;
    this.cincuenta_centavo = 0;
    this.billete_uno = 0
    this.billete_cinco = 0
    this.billete_diez = 0;
    this.billete_veinte = 0;
    this.billete_cincuenta = 0;
    this.billete_cien = 0;
    this.total_credito = 0;
    this.total_transferencia = 0

    this.total_tarjeta = 0;
    this.total_centavos = 0;
    this.total_cinco_centavo = 0;
    this.total_diez_centavo = 0;
    this.total_veinticion_centavo = 0;
    this.total_un_dolar = 0;
    this.total_cincuenta_centavo = 0;


    this.total_billete_uno = 0
    this.total_billete_cinco = 0
    this.total_billete_diez = 0;
    this.total_billete_veinte = 0;
    this.total_billete_cincuenta = 0;
    this.total_billete_cien = 0;

  }
  iniciarFacturacion() {
    this.clienteActual = new Clientes();
    this.emisor = new Emisor();
    this.porcentajeIva = 0.0;
    this.subTotal = 0.0;
    this.descTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    //this.efectivo = 0.0;
    this.tarjeta = 0.0;
    this.cambio = 0.0;
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", ],
      codcliente: [0, Validators.required],
      tipoidentificacion: [""],
      codigoProducto: [""],
      producto: [""],

    });
    this.listarGrupos();
    this.listarProveedor();
    this.listarProductoParaBuscar();
    this.listarFormaPago();
    this.tipoCompra = 'R'
    this.cargarEmisor(() => {
      this.onChangeCompra(this.tipoCompra);
    });
  }

  cargarEmisor(callback?: () => void) {
    const id = localStorage.getItem('id');

    this.apiEmisor.getEmisor(id).subscribe({
      next: (data: Emisor[]) => {
        if (data && data.length > 0) {
          this.emisor = data[0];
          console.log('Emisor cargado:', this.emisor);

          if (callback) {
            callback(); // ✅ ahora sí es seguro
          }
        }
      },
      error: err => console.error(err)
    });
  }


  validarCajaCerrada() {
    this.cajaServicio.validarCajaCerradaFacturacion(localStorage.getItem('id'),
      localStorage.getItem('usuario'), localStorage.getItem('caja'))
      .subscribe((
        data: Caja[]) => {
        this.listaCajaCerrada = data;

      }
        , err => {

        });
  }

  validarCaja(texto) {
    if (!texto) {
      return 'N';
    } else {
      return texto;
    }
  }

  validarAperturaCaja() {
    let cierre = localStorage.getItem('cierre_caja')
    cierre = this.validarCaja(cierre)
    if (cierre == 'S') {
      this.cajaServicio.validarCajaHabiertaFacturacion(localStorage.getItem('id'),
        localStorage.getItem('usuario'), localStorage.getItem('caja'))
        .subscribe((
          data: Caja[]) => {
          this.validarCajaCerrada();
          this.listaCajaAperturada = data;
          if (cierre == 'S' && this.listaCajaAperturada.length > 0) {
            this.total_apertura = this.listaCajaAperturada[0].total

            this.iniciarFacturacion();
          }
          if (cierre == 'S' && this.listaCajaAperturada.length == 0) {
            Swal.fire({
              title: "Alerta...",
              text: "La caja no está aperturada...",
              icon: "warning",
              confirmButtonText: "Aceptar",
            }).then((result) => {
              // El usuario hizo clic en "Aceptar" o cerró la alerta, en ambos casos navegamos a /caja
              this.router.navigate(['/caja']);
            });

          }

        }
          , err => {

          });
    } else {
      this.btnCerra = true;
      this.iniciarFacturacion();
    }
  }


  listarCliente() {

    this.api.getClientes(localStorage.getItem('id'))
      .subscribe((
        data: Clientes[]) => {
        this.clientes = data;
        console.log(this.clientes);
        this.tableClientes.setDataSource(this.clientes);
        this.tableClientes.dataSourceChange();
        this.previousCliente = this.mdbTable.getDataSource();
        this.lgCliente.show();
      }
        , err => {
          console.log(err);
          //this.isLoadingResults = false;
        });
  }


  abrirGaveta() {

    this.apiEmisor.abrirGaveta(localStorage.getItem('id'))
      .subscribe((
        data: Emisor[]) => {
        this.alertService.info('Gaveta abierta....');
      }
        , err => {
          console.log(err);
          this.alertService.danger('No se puede abrir la gaveta');
        });
  }


  imprimirRecibo(url: string, numeroFactura) {
    console.log(url);
    this.apiEmisor.imprimirLocal(localStorage.getItem('id'), url, numeroFactura)
      .subscribe((
        data: Emisor[]) => {
        this.alertService.info('Se envio a imprimir...');
      }
        , err => {
          console.log(err);
          this.alertService.danger('No se puede abrir la gaveta');
        });
  }



  grabarFactura() {
    let validar = false;

    if (this.clienteActual.codcliente == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar el cliente');
    } if (this.tipoCompra == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar tipo Comprobante');
    } if (this.formaPago == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar forma de Pago');
    }

    if (validar == false) {
      this.calcular();
      this.factura = new Factura();
      this.fecha = new Date();
      this.factura.tipoDoc = this.tipoCompra;
      this.factura.id = 0;
      this.factura.enviado = 'S'
      this.factura.numeroFactura = this.numeroDocumento;
      this.factura.total = this.total;
      this.factura.totalConImpuestos = this.total;
      this.factura.idCliente = this.clienteActual.codcliente;
      this.factura.idEmisor = Number(localStorage.getItem('id'));
      this.factura.idFormaPago = Number.parseInt(this.formaPago);
      this.factura.totalIva = this.iva;
      this.factura.totalSinImpuestos = this.subTotal;
      this.factura.totalDescuentos = this.descTotal;
      this.factura.valorEfectivo = this.efectivo;
      this.factura.valorTarjeta = this.tarjeta;
      this.factura.usuario = (localStorage.getItem('usuario'));
      this.factura.establecimiento = (localStorage.getItem('establecimiento'));
      this.facturaDetalles = [];
      this.index = 0;
      this.listaProductos.forEach((item) => {
        this.facturaDetalle = new FacturaDetalle();
        this.facturaDetalle.cantidad = item.cantidad;
        this.facturaDetalle.descripcion = item.nombre;
        this.facturaDetalle.idProducto = item.codigo;
        this.facturaDetalle.costo = item.costo;
        this.facturaDetalle.precioTotalSinImpuestos = item.total;
        if (item.precioDesc > 0) {
          this.facturaDetalle.precioUnitario = item.precioDesc;
        } else {
          this.facturaDetalle.precioUnitario = item.valorUnitario;
        }
        this.facturaDetalle.idUnidad = item.idUnidad;
        this.facturaDetalle.factor = item.factor;
        this.facturaDetalle.descuento = item.desc;
        this.facturaDetalle.enviado = 'S'
        this.facturaDetalle.valorIva = item.valorIva;
        //this.facturaDetalle.precioUnitario*this.porcentajeIva;
        this.facturaDetalles[this.index] = this.facturaDetalle;
        this.index++;

      })

      this.factura.det = this.facturaDetalles;
      this.factura.numeroFactura = this.numeroDocumento;
      this.factura.tipoDoc = this.tipoCompra;
      this.factura.caja = Number.parseInt(localStorage.getItem('caja'))
      this.facturas[0] = this.factura;
      this.apiFac.setActulizarFacturaRapido(this.facturas);
      this.alertService.info('Se guardo la factura...');
      this.ngOnInit_rapido();
      this.limpiar_rapido();
      this.lgFormaPago.hide();
      let url = ''
      /*
      if (this.factura.tipoDoc == 'F') {
         url = environment.apiReportes + "factura.rptdesign&__format=pdf&id=" + idFac;
         this.imprimirRecibo(url,idFac);
         const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

      } else {
         url = environment.apiReportes + "nota_venta.rptdesign&__format=pdf&id=" + idFac;
         this.imprimirRecibo(url,idFac);
         const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

      }*/
      this.tipoCompra = 'R'
      this.abrirGaveta();



      /* .subscribe(
         (data: Factura[]) => {
           this.facturasRespuesta = data;
           let idFac = this.facturasRespuesta[0].id
           this.ngOnInit();
           this.limpiar();
           this.lgFormaPago.hide();
           let url = ''
           /*
           if (this.factura.tipoDoc == 'F') {
              url = environment.apiReportes + "factura.rptdesign&__format=pdf&id=" + idFac;
              this.imprimirRecibo(url,idFac);
              const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
 
           } else {
              url = environment.apiReportes + "nota_venta.rptdesign&__format=pdf&id=" + idFac;
              this.imprimirRecibo(url,idFac);
              const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
 
           }*/
      //  this.abrirGaveta();


      //const printContent = document.getElementById(cmpName);
      //let doc = new jsPDF();
      //const pdfTable = this.content.nativeElement;
      //     doc.html(printContent, {callback: () => {
      //   doc.output('dataurlnewwindow');
      // }});

      //window.open(URL.createObjectURL(doc.output("blob")));

      //    window.open(URL.createObjectURL(doc.output("blob")));
      //   window.open('', '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
      //WindowPrt.document.write('');
      // WindowPrt.print();

      // this.tipoCompra = 'R'
      // },
      // error => {

      // this.alertService.warning(error);

      // }

      //);
    }
  }


  grabarFacturaEImprimir() {
    let validar = false;

    if (this.clienteActual.codcliente == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar el cliente');
    } if (this.tipoCompra == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar tipo Comprobante');
    } if (this.formaPago == null) {
      validar = true;
      this.alertService.danger('Debe seleccionar forma de Pago');
    }

    if (validar == false) {


      this.calcular();
      this.factura = new Factura();
      this.fecha = new Date();
      this.factura.tipoDoc = this.tipoCompra;
      this.factura.id = 0;
      this.factura.enviado = 'S'
      this.factura.numeroFactura = this.numeroDocumento;
      this.factura.total = this.total;
      this.factura.totalConImpuestos = this.total;
      this.factura.idCliente = this.clienteActual.codcliente;
      this.factura.idEmisor = Number(localStorage.getItem('id'));
      this.factura.idFormaPago = Number.parseInt(this.formaPago);
      this.factura.totalIva = this.iva;
      this.factura.totalSinImpuestos = this.subTotal;
      this.factura.totalDescuentos = this.descTotal;
      this.factura.valorEfectivo = this.efectivo;
      this.factura.valorTarjeta = this.tarjeta;
      this.factura.usuario = (localStorage.getItem('usuario'));
      this.factura.establecimiento = (localStorage.getItem('establecimiento'));
      this.facturaDetalles = [];
      this.index = 0;
      this.listaProductos.forEach((item) => {
        this.facturaDetalle = new FacturaDetalle();
        this.facturaDetalle.cantidad = item.cantidad;
        this.facturaDetalle.descripcion = item.nombre;
        this.facturaDetalle.idProducto = item.codigo;
        this.facturaDetalle.costo = item.costo;
        this.facturaDetalle.precioTotalSinImpuestos = item.total;
        if (item.precioDesc > 0) {
          this.facturaDetalle.precioUnitario = item.precioDesc;
        } else {
          this.facturaDetalle.precioUnitario = item.valorUnitario;
        }
        this.facturaDetalle.idUnidad = item.idUnidad;
        this.facturaDetalle.factor = item.factor;
        this.facturaDetalle.descuento = item.desc;
        this.facturaDetalle.enviado = 'S'
        this.facturaDetalle.valorIva = item.valorIva;
        //this.facturaDetalle.precioUnitario*this.porcentajeIva;
        this.facturaDetalles[this.index] = this.facturaDetalle;
        this.index++;

      })

      this.factura.det = this.facturaDetalles;
      this.factura.numeroFactura = this.numeroDocumento;
      this.factura.tipoDoc = this.tipoCompra;
      this.factura.caja = Number.parseInt(localStorage.getItem('caja'))
      this.facturas[0] = this.factura;
      this.apiFac.setActulizarFactura(this.facturas).subscribe(
        (data: Factura[]) => {
          this.facturasRespuesta = data;
          let idFac = this.facturasRespuesta[0].id
          this.ngOnInit_rapido();
          this.limpiar_rapido();
          this.alertService.info('Se guardo la factura...');
          this.lgFormaPago.hide();
          let url = ''
          this.abrirGaveta();
          if (this.factura.tipoDoc == 'F') {
            url = environment.apiReportes + "factura.rptdesign&__format=pdf&id=" + idFac;
            this.imprimirRecibo(url, idFac);
            //       const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

          } else {
            url = environment.apiReportes + "nota_venta.rptdesign&__format=pdf&id=" + idFac;
            this.imprimirRecibo(url, idFac);
            //     const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');

          }


          //const printContent = document.getElementById(cmpName);
          //let doc = new jsPDF();
          //const pdfTable = this.content.nativeElement;
          //     doc.html(printContent, {callback: () => {
          //   doc.output('dataurlnewwindow');
          // }});

          //window.open(URL.createObjectURL(doc.output("blob")));

          //    window.open(URL.createObjectURL(doc.output("blob")));
          //   window.open('', '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
          //WindowPrt.document.write('');
          // WindowPrt.print();
          this.tipoCompra = 'R'
        },
        error => {

          this.alertService.warning(error);

        }

      );
    }
  }


  cargarClientes() {
    this.searchCliente = "";
    this.listarCliente();



  }


  limpiar_rapido() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: [""],
      codcliente: [0, Validators.required],
      tipoidentificacion: [""],
      producto: [""],
      codigoProducto: [""]
    });
    this.total = 0;
    this.subTotal = 0;
    this.iva = 0;
    this.tipoCompra = 'R';

    this.numeroDocumento = null;
    //this.listarProveedor();
    this.listaProductos = [];
    this.total = 0;
    this.descTotal = 0;
    this.iva = 0;
    this.subTotal = 0;
this.listarProveedor();
this.isRecibo=true
this.onChangeCompra(this.tipoCompra);


  }


  limpiar() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: ["", ],
      codcliente: [0, ],
      tipoidentificacion: [""],
      producto: [""],
      codigoProducto: [""]
    });
    this.total = 0;
    this.subTotal = 0;
    this.iva = 0;
    // this.tipoCompra = null;
    this.numeroDocumento = null;
    this.listarProveedor();
    this.listaProductos = [];
    this.total = 0;
    this.descTotal = 0;
    this.iva = 0;
    this.subTotal = 0;


  }


  pagar() {

    this.grabarFactura();


  }


  pagareImprmir() {

    this.grabarFacturaEImprimir();


  }


  agregarCliente() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ["", Validators.required],
      numeroidentificacion: ["", Validators.required],
      direccion: ["", Validators.required],
      telefonoconvencional: ["", Validators.required],
      celular: ["", Validators.required],
      correo: ["", Validators.required],
      tipoCliente: [""],
      codcliente: [0, Validators.required],
      tipoidentificacion: [""],
      producto: [""],
    });

    this.mdbModal.show();
  }
  cierre(content) {

    if (this.listaCajaCerrada.length > 0) {
      Swal.fire({
        title: "Alerta....",
        text: "Caja esta cerrada",
        icon: "error",
        confirmButtonText: "Aceptar",
      }).then((willDelete) => {
        if (willDelete) {

        } else {

        }
      });

    } else {
      this.limpiarCierre();

      this.apiFac
        .getVentasDia(
          Number.parseInt(localStorage.getItem("id")),
          localStorage.getItem("usuario"),
          Number.parseInt(localStorage.getItem("caja")),
        )
        .subscribe(
          (data: ventasDia[]) => {
            this.ventasDia = data;
            this.ventasDia.forEach(e => {
              if ("EFECTIVO" === e.descripcion) {
                this.total_efectivo = this.redondearValor(e.total)
              }
              if ("CREDITO" === e.descripcion) {
                this.total_credito = this.redondearValor(e.total)
              }
              if ("TRANSFERENCIA" === e.descripcion) {
                this.total_transferencia = this.redondearValor(e.total)
              }
              if ("TARJETA" === e.descripcion) {
                this.total_tarjeta = (e.total)
              }
            });
            this.modalService.open(content, { size: 'lg' })
          });


    }
  }

  actulizarCliente() {

if (this.editForm.invalid) {
    this.alertService.warning("Complete los campos obligatorios");
    return;
  }

    this.clienteNuevo = new Clientes();
    this.clienteNuevo.nombrerazonsocial = 
    this.editForm.controls.nombrerazonsocial.value;
    this.clienteNuevo.numeroidentificacion = 
    this.editForm.controls.numeroidentificacion.value;
    this.clienteNuevo.direccion = this.editForm.controls.direccion.value;
    this.clienteNuevo.telefonoconvencional = this.editForm.controls.telefonoconvencional.value;
    this.clienteNuevo.celular = this.editForm.controls.celular.value;
    this.clienteNuevo.tipoCliente = this.editForm.controls.tipoCliente.value;
    this.clienteNuevo.codcliente = this.editForm.controls.codcliente.value;
    this.clienteNuevo.correo = this.editForm.controls.correo.value;
    this.clienteNuevo.tipoidentificacion = 'C';
    this.clienteNuevo.enviado = 'S';
    this.clienteNuevo.idEmisor = Number(localStorage.getItem("id"));
    this.listaClientesActulizar[0] = this.clienteNuevo;
    this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

      data => {
        this.alertService.success("Se agrego un nuevo cliente");
        this.mdbModal.hide();
        this.listarProveedor();

      },

      error => {

        this.alertService.danger(error.error)

      }

    );



  }

  listarFormaPago() {
    this.apiForma
      .getformaPago(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: formaPago[]) => {
          this.formaPagoList = data;
          this.formaPagoList.forEach(element => {
            if (element.descripcion === 'EFECTIVO') {
              this.formaPago = element.id.toString()
            }
          });
        });
  }


  listarProductoParaBuscar() {
    this.apiProducto.getProducto(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.productosTodos = data;
        this.productos = this.productosTodos.filter(a => a.grupo === 'PANADERIA')
        //this.grupos=this.grupos.filter(a=>a.tipo!='INICIO');


      }
        , err => {
          console.log(err);

        });

  }

  buscarProductoCategoria(categoria: string) {
    // this.productos=this.productosTodos.filter(a=>a.grupo==='PANADERIA' || a.grupo===categoria)
    this.productos = this.productosTodos.filter(a => a.grupo === categoria)

  }


  listarGrupos() {

    this.apiGrupo.getGrupo(localStorage.getItem('id'))
      .subscribe((
        data: grupoProducto[]) => {
        this.gruposLista = data;

        this.grupos = this.gruposLista.filter(a => a.color !== null && a.color !== '');

      }
        , err => {
          console.log(err);

        });
  }

  listarProveedor() {
    this.api
      .getClientes(
        localStorage.getItem("id")
      )
      .subscribe(
        (data: Clientes[]) => {
          this.listCliene = data;
          this.listCliene.forEach(element => {
            if (element.numeroidentificacion == '9999999999') {
              this.clienteActual = element;
            }
          });

          console.log(this.listCliene);
        });
  }




  valueChangeDesc(produc: Producto) {
    let valorDes = 0;
    this.productoSelecionado = produc;
    this.productoSelecionado.total =
      this.productoSelecionado.cantidad *
      this.productoSelecionado.valorUnitario;

    if (this.emisor.descuento == 'P') {
      valorDes =
        produc.desc * this.productoSelecionado.total;
    } else {
      valorDes = produc.desc;
    }
    this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
    this.productoSelecionado.valdesc = valorDes;
    this.productoSelecionado.precioDesc = this.productoSelecionado.total / this.productoSelecionado.cantidad;
    this.calcular();

  }


  validarNumeros(numero) {
    if (!numero) {
      return 0;
    } else {
      return numero;
    }
  }

  searchItems(newValue) {
    this.searchCliente = newValue

    if (!this.searchText) {

      this.listarProducto()
    }


    if (this.searchText) {
      const resulta =
        this.productos.filter(item => {
          return item.nombre.includes(this.searchText.toUpperCase());
        })

      this.productos = resulta;
    }
  }


  searchClientes(newValue) {
    this.searchCliente = newValue
    const prev = this.tableClientes.getDataSource();

    if (!this.searchCliente) {
      this.tableClientes.setDataSource(this.previousCliente);
      this.clientes = this.tableClientes.getDataSource();
    }

    if (this.searchCliente) {
      this.clientes = this.tableClientes.searchLocalDataBy(this.searchCliente);
      this.tableClientes.setDataSource(prev);
    }
  }
  listarProducto() {
    this.apiProducto.getProducto(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.productos = data;
        console.log(this.productos);


      }
        , err => {
          console.log(err);
          //  this.isLoadingResults = false;
        });



  }

  selecionarUnidadVenta(productoPrecio: ProductoPrecio) {
    this.index = 0;

    this.apiUnidad.getUnidad(productoPrecio.idUnidad.toString())
      .subscribe((
        varUnidades: Unidades[]) => {

        varUnidades.forEach(elemUnidad => {

          elemUnidad.precio = productoPrecio.precioVenta;

          this.unidadesVenta[this.index] = elemUnidad;
          this.productoSelecionado.selectUnidad = productoPrecio.idUnidad.toString();
          this.productoSelecionado.unidadesVenta = this.unidadesVenta
          this.productoSelecionado.cantidad = 1;
          this.productoSelecionado.desc = 0;
          this.onChangeUnidad(productoPrecio.idUnidad.toString(), this.productoSelecionado)
          this.valueChangeDesc(this.productoSelecionado)
          this.valueChangeCantidad(this.productoSelecionado)
          this.productoSelecionado.desc = 0;
          this.productoSelecionado.cantidad = 1;
          this.productoSelecionado.total =
            this.productoSelecionado.cantidad *
            this.productoSelecionado.valorUnitario;
          this.productoSelecionado.ordenar = this.listaProductos.length + 1;
          this.selectedRowIndex = this.productoSelecionado.ordenar
          this.inputValue = ''
          this.listaProductos.push(this.productoSelecionado);


          this.index++;


          this.lgUnidadModal.hide();
        });
      }
      );

  }

  abrirModalVariosUnidades(lista: ProductoPrecio[]) {
    this.ProductoPrecioxUnidades = lista
    this.ProductoPrecioxUnidades.forEach(element => {
      element.descripcion = this.listaUnidad.find(a => a.id == element.idUnidad).descripcion


    });

    this.lgUnidadModal.show();
    /* this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
       .subscribe((
         varProdcutoPrecio: ProductoPrecio[]) => {
 
         if (varProdcutoPrecio.length > 1) {
           this.ProductoPrecioxUnidades = varProdcutoPrecio
           this.ProductoPrecioxUnidades.forEach(element => {
             element.descripcion = this.listaUnidad.find(a => a.id == element.idUnidad).descripcion
 
           });
           this.lgUnidadModal.show()
         }
       });*/

  }

  listarUnidadesVenta() {

    this.apiUnidad.getUnidadesVenta(localStorage.getItem('id')).subscribe((
      data: Unidades[]) => {
      this.listaUnidad = data;
      //  console.log(this.unidadesVenta);

    }
      , err => {
        console.log(err);

      });

  }


  buscarUnidadxProducto(unidad) {
    this.apiUnidad.getUnidad(unidad)
      .subscribe((
        varUnidades: Unidades[]) => {
        this.listaUnidad = varUnidades
      }
      );

  }

buscarProductoMal(codigLector: string) {

  if (!codigLector) return;

  const varInventario =
    localStorage.getItem("inventario");

  of(
    this.productos.filter(
      p => p.codigoPrincipal === codigLector
    )
  )
  .pipe(

    switchMap((productos: Producto[]) => {

      if (!productos || productos.length === 0) {

        this.alertService.danger(
          "No existe el producto..."
        );

        return of(null);
      }

      const productoBase = productos[0];

      // 🔹 Con inventario
      if (
        productoBase.tipoProducto === 'P' &&
        varInventario === 'S'
      ) {

        return forkJoin({

          inventario:
            this.apiCompras.inventarioProducto(
              productoBase.codigo
            ),

          precios:
            this.apiProducto.getProductoPrecio(
              productoBase.codigo.toString(),
              productoBase.idEmisor.toString()
            ),

          producto:
            of(productoBase)

        });
      }

      // 🔹 Sin inventario
      return forkJoin({

        inventario: of(null),

        precios:
          this.apiProducto.getProductoPrecio(
            productoBase.codigo.toString(),
            productoBase.idEmisor.toString()
          ),

        producto:
          of(productoBase)

      });

    })

  )
  .subscribe({

    next: (result: any) => {

      if (!result) return;

      const {
        inventario,
        precios,
        producto
      } = result;

      // 🔹 Validar stock
      if (
        inventario &&
        inventario.cantidad <= 0
      ) {

        this.alertService.danger(
          "No hay stock..."
        );

        return;
      }

      // 🔹 Validar precios
      if (
        !precios ||
        precios.length === 0
      ) {

        this.alertService.danger(
          "El producto no tiene precio..."
        );

        return;
      }

      // 🔹 Varias unidades
      if (precios.length > 1) {

        this.nombreProductoUnidad =
          producto.nombre;

        this.productoSelecionado =
          JSON.parse(JSON.stringify(producto));

        this.abrirModalVariosUnidades(
          precios
        );

        return;
      }

      // 🔹 Una sola unidad
      const precio = precios[0];

      this.apiUnidad
        .getUnidad(precio.idUnidad.toString())
        .subscribe(

          (unidades: Unidades[]) => {

            const unidad = unidades[0];

            // 🔹 PRODUCTO INDEPENDIENTE
            const productoNuevo: any =
              JSON.parse(
                JSON.stringify(producto)
              );

            // 🔹 UNIDADES INDEPENDIENTES
            productoNuevo.unidadesVenta = [

              JSON.parse(JSON.stringify({

                ...unidad,

                precio:
                  precio.precioVenta

              }))

            ];

            // 🔹 Unidad seleccionada
            productoNuevo.selectUnidad =
              unidad.id.toString();

            // 🔹 Cantidad
            productoNuevo.cantidad =
              this.pesoCantidad
                ? parseFloat(
                    this.pesoCantidad
                  )
                : 1;

            // 🔹 Descuento
            productoNuevo.desc = 0;

            // 🔹 Cambio unidad
            this.onChangeUnidad(
              productoNuevo.selectUnidad,
              productoNuevo
            );

            // 🔹 Calcular descuento
            this.valueChangeDesc(
              productoNuevo
            );

            // 🔹 Total
            productoNuevo.total =
              productoNuevo.cantidad *
              productoNuevo.valorUnitario;

            // 🔹 Orden
            productoNuevo.ordenar =
              this.listaProductos.length + 1;

            this.selectedRowIndex =
              productoNuevo.ordenar;

            // 🔹 AGREGAR
            this.listaProductos.push(
              productoNuevo
            );

            // 🔹 Refrescar tabla
            this.mdbTable.setDataSource(
              this.listaProductos
            );

            this.mdbTable.dataSourceChange();

            // 🔹 Recalcular factura
            this.calcular();

            // 🔹 Limpiar
            this.codigoProducto = "";

            this.searchText = "";

          },

          err => {

            console.log(err);

            this.alertService.danger(
              "Problemas obteniendo unidad"
            );

          }

        );

    },

    error: () => {

      this.alertService.danger(
        "Problemas con la conexión"
      );

    }

  });

}

  buscarProducto(codigLector: string) {


    if (codigLector != null) {
      this.apiProducto
        .getProductoPorCodigo(
          codigLector,
          localStorage.getItem("id")
        )
        .subscribe(
          (data: Producto[]) => {

            console.log(data);
            data.forEach((item) => {
              this.resul = true;
              this.productoSelecionado = new Producto();

              this.productoSelecionado = item;

              if (this.productoSelecionado == null) {
                this.alertService.danger("No existe el producto...");
                this.codigoProducto = "";
              } else {
                let varInventario = localStorage.getItem('inventario')
                if (this.productoSelecionado.tipoProducto == 'P' && ('S' == varInventario)) {

                  this.apiCompras
                    .inventarioProducto(this.productoSelecionado.codigo)
                    .subscribe((dataInv: Inventario) => {
                      console.log(dataInv);
                      this.inventario = dataInv;
                      if (dataInv.cantidad == null) {
                        this.alertService.danger("No hay stock...");
                        this.productoSelecionado.codigoPrincipal = null;

                      } else {
                        if (dataInv.cantidad > 0) {

                          this.unidadesVenta = [];
                          this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                            .subscribe((
                              varProdcutoPrecio: ProductoPrecio[]) => {
                              if (varProdcutoPrecio.length > 1) {
                                this.nombreProductoUnidad = this.productoSelecionado.nombre
                                this.abrirModalVariosUnidades(varProdcutoPrecio)
                              } else {
                                varProdcutoPrecio.forEach(element => {
                                  this.index = 0;
                                  this.apiUnidad.getUnidad(element.idUnidad.toString())
                                    .subscribe((
                                      varUnidades: Unidades[]) => {

                                      varUnidades.forEach(elemUnidad => {

                                        elemUnidad.precio = element.precioVenta;

                                        this.unidadesVenta[this.index] = elemUnidad;
                                        this.productoSelecionado.selectUnidad = elemUnidad.id.toString();

                                        this.productoSelecionado.cantidad = 1;
                                        this.productoSelecionado.precioDesc = 0;
                                        this.onChangeUnidad(this.productoSelecionado.selectUnidad, this.productoSelecionado)
                                        this.valueChangeDesc(this.productoSelecionado)
                                      });
                                      console.log(varProdcutoPrecio);
                                      this.index++;
                                    }
                                      , err => {
                                        console.log(err);

                                      });



                                });
                                if (varProdcutoPrecio.length > 0) {
                                  this.productoSelecionado.unidadesVenta = this.unidadesVenta;

                                  this.codigoProducto = "";
                                  this.productoSelecionado.desc = 0
                                  if (this.pesoCantidad == null) {
                                    this.productoSelecionado.cantidad = 1;


                                  } else {
                                    this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                                  }

                                  this.productoSelecionado.total =
                                    this.productoSelecionado.cantidad *
                                    this.productoSelecionado.valorUnitario;
                                  this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                                  this.selectedRowIndex = this.productoSelecionado.ordenar
                                  this.listaProductos.push(this.productoSelecionado);

                                } else {
                                  if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                                    this.productoSelecionado.desc = 0;
                                    this.productoSelecionado.cantidad = 1;
                                    this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                                    this.productoSelecionado.total =
                                      this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                                    this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                                    this.selectedRowIndex = this.productoSelecionado.ordenar
                                    this.inputValue = ''
                                    this.listaProductos.push(this.productoSelecionado);
                                    this.valueChangeDesc(this.productoSelecionado)
                                  } else {

                                    this.alertService.danger("El producto no tiene precio....");
                                  }
                                }

                              }

                              console.log(varProdcutoPrecio);

                            }
                              , err => {
                                console.log(err);

                              });
                        } else {
                          this.alertService.danger('No tiene stock....')
                        }
                      }


                    });
                } else {
                  this.unidadesVenta = [];
                  this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                    .subscribe((
                      varProdcutoPrecio: ProductoPrecio[]) => {
                      if (varProdcutoPrecio.length > 1) {
                        this.nombreProductoUnidad = this.productoSelecionado.nombre
                        this.abrirModalVariosUnidades(varProdcutoPrecio)
                      } else {
                        this.index = 0;
                        varProdcutoPrecio.forEach(element => {

                          this.apiUnidad.getUnidad(element.idUnidad.toString())
                            .subscribe((
                              varUnidades: Unidades[]) => {

                              varUnidades.forEach(elemUnidad => {


                                this.unidadesVenta[this.index] = elemUnidad;
                                this.productoSelecionado.selectUnidad = elemUnidad.id.toString();

                                this.productoSelecionado.cantidad = 1;
                                this.productoSelecionado.desc = 0;
                                this.onChangeUnidad(this.productoSelecionado.selectUnidad, this.productoSelecionado)
                                this.valueChangeDesc(this.productoSelecionado)
                                this.valueChangeCantidad(this.productoSelecionado)
                              });
                              this.index++;

                            }
                              , err => {
                                console.log(err);

                              });



                        });
                        if (varProdcutoPrecio.length > 0) {
                          this.productoSelecionado.unidadesVenta = this.unidadesVenta;
                          this.codigoProducto = ""
                          if (this.pesoCantidad == null) {
                            this.productoSelecionado.cantidad = 1;


                          } else {
                            this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                          }
                          this.productoSelecionado.desc = 0;
                          this.productoSelecionado.cantidad = 1;
                          this.productoSelecionado.total =
                            this.productoSelecionado.cantidad *
                            this.productoSelecionado.valorUnitario;
                          //     this.productoSelecionado.ordenar = this.obtenerSiguienteOrden();
                          this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                          this.selectedRowIndex = this.productoSelecionado.ordenar
                          this.inputValue = ''
                          this.listaProductos.push(this.productoSelecionado);

                        } else {
                          if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                            this.productoSelecionado.cantidad = 1;
                            this.productoSelecionado.desc = 0;
                            this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                            this.productoSelecionado.total =
                              this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                            this.productoSelecionado.ordenar = this.listaProductos.length + 1;

                            (this.productoSelecionado);
                            this.inputValue = ''
                            this.valueChangeDesc(this.productoSelecionado)
                          } else {

                            this.alertService.danger("El producto no tiene precio....");
                          }
                        }
                      }
                      console.log(varProdcutoPrecio);

                    }
                      , err => {
                        console.log(err);

                      });

                }
              }
            }

            );
            if (data.length == 0) {
              this.alertService.danger("No existe el producto...");
              this.codigoProducto = "";
            }
            if (this.resul === false) {
              this.alertService.danger("No existe el producto...");
              this.codigoProducto = "";
            }
          },
          (err) => {
            this.alertService.danger("Problemas con la conexión");
          }
        );


      this.mdbTable.setDataSource(this.listaProductos);
      this.mdbTable.dataSourceChange();
      this.calcular();
    }
    this.searchText = "";
    //this.searchItems();
  }


  buscarProducto2(codigLector: string) {


    if (codigLector != null) {
      this.apiProducto
        .getProductoPorCodigo(
          codigLector,
          localStorage.getItem("id")
        )
        .subscribe(
          (data: Producto[]) => {

            data.forEach((item) => {
              this.resul = true;
              this.productoSelecionado = new Producto();

              this.productoSelecionado = item;

              if (this.productoSelecionado == null) {
                this.alertService.danger("No existe el producto...");
                this.codigoProducto = "";
              } else {
                let varInventario = localStorage.getItem('inventario')
                if (this.productoSelecionado.tipoProducto == 'P' && ('S' == varInventario)) {

                  this.apiCompras
                    .inventarioProducto(this.productoSelecionado.codigo)
                    .subscribe((dataInv: Inventario) => {
                      console.log(dataInv);
                      this.inventario = dataInv;
                      if (dataInv.cantidad == null) {
                        this.alertService.danger("No hay stock...");
                        this.productoSelecionado.codigoPrincipal = null;

                      } else {
                        if (dataInv.cantidad > 0) {

                          this.unidadesVenta = [];
                          this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                            .subscribe((
                              varProdcutoPrecio: ProductoPrecio[]) => {
                              if (varProdcutoPrecio.length > 1) {
                                this.nombreProductoUnidad = this.productoSelecionado.nombre
                                this.abrirModalVariosUnidades(varProdcutoPrecio)
                              } else {
                                varProdcutoPrecio.forEach(element => {
                                  this.index = 0;
                                  this.apiUnidad.getUnidad(element.idUnidad.toString())
                                    .subscribe((
                                      varUnidades: Unidades[]) => {

                                      varUnidades.forEach(elemUnidad => {

                                        elemUnidad.precio = element.precioVenta;

                                        this.unidadesVenta[this.index] = elemUnidad;
                                        this.productoSelecionado.selectUnidad = elemUnidad.id.toString();

                                        this.productoSelecionado.cantidad = 1;
                                        this.productoSelecionado.precioDesc = 0;
                                        this.onChangeUnidad(this.productoSelecionado.selectUnidad, this.productoSelecionado)
                                        this.valueChangeDesc(this.productoSelecionado)
                                      });
                                      console.log(varProdcutoPrecio);
                                      this.index++;
                                    }
                                      , err => {
                                        console.log(err);

                                      });



                                });
                                if (varProdcutoPrecio.length > 0) {
                                  this.productoSelecionado.unidadesVenta = this.unidadesVenta;

                                  this.codigoProducto = "";
                                  this.productoSelecionado.desc = 0
                                  if (this.pesoCantidad == null) {
                                    this.productoSelecionado.cantidad = 1;


                                  } else {
                                    this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                                  }

                                  this.productoSelecionado.total =
                                    this.productoSelecionado.cantidad *
                                    this.productoSelecionado.valorUnitario;
                                  this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                                  this.selectedRowIndex = this.productoSelecionado.ordenar
                                  this.listaProductos.push(this.productoSelecionado);

                                } else {
                                  if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                                    this.productoSelecionado.desc = 0;
                                    this.productoSelecionado.cantidad = 1;
                                    this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                                    this.productoSelecionado.total =
                                      this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                                    this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                                    this.selectedRowIndex = this.productoSelecionado.ordenar
                                    this.inputValue = ''
                                    this.listaProductos.push(this.productoSelecionado);
                                    this.valueChangeDesc(this.productoSelecionado)
                                  } else {

                                    this.alertService.danger("El producto no tiene precio....");
                                  }
                                }

                              }

                              console.log(varProdcutoPrecio);

                            }
                              , err => {
                                console.log(err);

                              });
                        } else {
                          this.alertService.danger('No tiene stock....')
                        }
                      }


                    });
                } else {
                  this.unidadesVenta = [];
                  this.apiProducto.getProductoPrecio(this.productoSelecionado.codigo.toString(), this.productoSelecionado.idEmisor.toString())
                    .subscribe((
                      varProdcutoPrecio: ProductoPrecio[]) => {
                      if (varProdcutoPrecio.length > 1) {
                        this.nombreProductoUnidad = this.productoSelecionado.nombre
                        this.abrirModalVariosUnidades(varProdcutoPrecio)
                      } else {
                        this.index = 0;
                        varProdcutoPrecio.forEach(element => {

                          this.apiUnidad.getUnidad(element.idUnidad.toString())
                            .subscribe((
                              varUnidades: Unidades[]) => {

                              varUnidades.forEach(elemUnidad => {


                                this.unidadesVenta[this.index] = elemUnidad;
                                this.productoSelecionado.selectUnidad = elemUnidad.id.toString();

                                this.productoSelecionado.cantidad = 1;
                                this.productoSelecionado.desc = 0;
                                this.onChangeUnidad(this.productoSelecionado.selectUnidad, this.productoSelecionado)
                                this.valueChangeDesc(this.productoSelecionado)
                                this.valueChangeCantidad(this.productoSelecionado)
                              });
                              this.index++;

                            }
                              , err => {
                                console.log(err);

                              });



                        });
                        if (varProdcutoPrecio.length > 0) {
                          this.productoSelecionado.unidadesVenta = this.unidadesVenta;
                          this.codigoProducto = ""
                          if (this.pesoCantidad == null) {
                            this.productoSelecionado.cantidad = 1;


                          } else {
                            this.productoSelecionado.cantidad = parseFloat(this.pesoCantidad);
                          }
                          this.productoSelecionado.desc = 0;
                          this.productoSelecionado.cantidad = 1;
                          this.productoSelecionado.total =
                            this.productoSelecionado.cantidad *
                            this.productoSelecionado.valorUnitario;
                          //     this.productoSelecionado.ordenar = this.obtenerSiguienteOrden();
                          this.productoSelecionado.ordenar = this.listaProductos.length + 1;
                          this.selectedRowIndex = this.productoSelecionado.ordenar
                          this.inputValue = ''
                          this.listaProductos.push(this.productoSelecionado);

                        } else {
                          if (this.productoSelecionado.costo > 0 && this.productoSelecionado.utilidad > 0) {
                            this.productoSelecionado.cantidad = 1;
                            this.productoSelecionado.desc = 0;
                            this.productoSelecionado.valorUnitario = this.productoSelecionado.costo * this.productoSelecionado.utilidad + this.productoSelecionado.costo
                            this.productoSelecionado.total =
                              this.productoSelecionado.cantidad * this.productoSelecionado.valorUnitario;
                            this.productoSelecionado.ordenar = this.listaProductos.length + 1;

                            (this.productoSelecionado);
                            this.inputValue = ''
                            this.valueChangeDesc(this.productoSelecionado)
                          } else {

                            this.alertService.danger("El producto no tiene precio....");
                          }
                        }
                      }
                      console.log(varProdcutoPrecio);

                    }
                      , err => {
                        console.log(err);

                      });

                }
              }
            }

            );
            if (data.length == 0) {
              this.alertService.danger("No existe el producto...");
              this.codigoProducto = "";
            }
            if (this.resul === false) {
              this.alertService.danger("No existe el producto...");
              this.codigoProducto = "";
            }
          },
          (err) => {
            this.alertService.danger("Problemas con la conexión");
          }
        );


      this.mdbTable.setDataSource(this.listaProductos);
      this.mdbTable.dataSourceChange();
      this.calcular();
    }
    this.searchText = "";
    //this.searchItems();
  }

  obtenerSiguienteOrden(): number {
    if (!this.listaProductos || this.listaProductos.length === 0) {
      return 1;
    }
    return this.listaProductos[this.listaProductos.length - 1].orden + 1;
  }



  eliminar(orden: number) {
    const ordenNumber = Number(orden);

    const index = this.listaProductos.findIndex(
      p => Number(p.ordenar) === ordenNumber
    );

    if (index === -1) {
      console.log(`No se encontró un producto con el orden: ${ordenNumber}`);
      return;
    }

    // Eliminar
    this.listaProductos.splice(index, 1);

    // 🔥 REORDENAR (CLAVE)
    this.listaProductos.forEach((p, i) => {
      p.ordenar = i + 1;
    });

    // Refrescar tabla
    this.mdbTable.setDataSource(this.listaProductos);
    this.mdbTable.dataSourceChange();

    this.calcular();
  }

  actualizarEfectivo(event: any): void {
    const valor = parseFloat(event);
    this.efectivo = isNaN(valor) ? 0 : valor; // Si no es un número, asignamos 0
    this.calcularCobro(); // Llama a calcular cada vez que cambia el valor
  }
  cobrar() {
    //this.efectivo = this.total;
    //this.efectivo=0;
    //this.efectivo = this.efectivo.toFixed(2) as unknown as number;
    this.tarjeta = 0;
    this.cambio = 0;

    this.calcularCobro();

    this.lgFormaPago.show();
    this.efectivo = 0
    //this.miEfectivo.nativeElement.focus();

  }

  redondearValor(numero: number) {

    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }

  calcularCobro() {
    this.cambio = (this.efectivo + this.tarjeta) - this.total;
    this.cambio = this.cambio.toFixed(2) as unknown as number;

  }




  limpiarBoton() {
    this.listaProductos.forEach((item) => {
      item.cantidad = 0;
      item.total = 0;
    });

  }


  calcular() {
    this.subTotal = 0.0;
    this.iva = 0.0;
    this.total = 0.0;
    this.descTotal = 0.0;

    this.listaProductos.forEach((item) => {

      if (item.iva == "N") {
        item.valorIva = item.total * 0;
      } else {
        // if (this.tipoCompra == 'F'){
        item.valorIva = item.total * this.porcentajeIva;
        // }

      }
      this.subTotal = this.subTotal + item.total;
      this.iva = this.iva + item.valorIva;
    });

    this.listaProductos.forEach((item) => {
      this.descTotal = this.descTotal + item.valdesc;
    });
    //this.iva = this.subTotal * this.porcentajeIva;
    this.total = this.subTotal + this.iva;
  }
  valueChangeCantidad(produc: Producto) {
    let valorDes = 0;
    this.productoSelecionado = produc;
    this.productoSelecionado.total =
      this.productoSelecionado.cantidad *
      this.productoSelecionado.valorUnitario;
    if (this.tipoCompra == 'F') {
      this.productoSelecionado.valorIva =
        this.productoSelecionado.total *
        this.porcentajeIva;
    } else {
      this.productoSelecionado.valorIva =
        this.productoSelecionado.total *
        0;
    }

    if (produc.desc !== undefined) {

      if (this.emisor.descuento === 'P') {
        valorDes =
          produc.desc * this.productoSelecionado.total;
      } else {
        valorDes =
          produc.desc;
      }
      this.productoSelecionado.total = this.productoSelecionado.total - valorDes;
      this.productoSelecionado.valdesc = valorDes;
    }

    this.calcular();
    let idEmisor = localStorage.getItem('inventario')
    if (this.productoSelecionado.tipoProducto == 'P' && ('N' !== idEmisor)) {

      if (this.inventario.cantidad < this.productoSelecionado.cantidad) {
        this.alertService.danger('No hay stock...');
        produc.cantidad = this.productoSelecionado.cantidad;
        this.productoSelecionado.total =
          this.productoSelecionado.cantidad *
          this.productoSelecionado.valorUnitario;
        this.calcular();
      }
    }
  }

  peso(entidad: Producto) {
    this.apiFac.getUltimoPeso(localStorage.getItem("id"))
      .subscribe((
        varPeso: Peso[]) => {
        varPeso.forEach(elemUnidad => {
          entidad.cantidad = elemUnidad.peso
          this.valueChangeCantidad(entidad);
        })
      });

  }

onChangeUnidadMal(newValue: any, produc: Producto) {

  this.apiProducto
    .buscarProductoPrecioUnidadProducto(
      newValue,
      produc.codigo
    )
    .subscribe(

      (varPrecios: ProductoPrecio[]) => {

        if (
          !varPrecios ||
          varPrecios.length === 0
        ) return;

        const element = varPrecios[0];

        this.apiUnidad
          .getUnidad(
            element.idUnidad.toString()
          )
          .subscribe(

            (varUni: Unidades[]) => {

              if (
                !varUni ||
                varUni.length === 0
              ) return;

              const elementU = varUni[0];

              // 🔹 Precio
              if (
                this.emisor.preciosIva === 'S' &&
                this.tipoCompra === 'F' &&
                produc.iva === 'S'
              ) {

                let valor =
                  this.emisor.iva
                    .toString()
                    .replace('0', '1');

                produc.valorUnitario =
                  element.precioVenta /
                  Number.parseFloat(valor);

              } else {

                produc.valorUnitario =
                  element.precioVenta;
              }

              // 🔹 Unidad actual
              produc.factor =
                elementU.factor;

              produc.idUnidad =
                element.idUnidad;

              // 🔹 Total
              produc.total =
                produc.cantidad *
                produc.valorUnitario;

              // 🔹 Descuento
              this.valueChangeDesc(
                produc
              );

              // 🔹 Total factura
              this.calcular();

            },

            err => {
              console.log(err);
            }

          );

      },

      err => {
        console.log(err);
      }

    );

}

  onChangeUnidad(newValue, produc: Producto) {
    this.apiProducto.buscarProductoPrecioUnidadProducto(newValue, produc.codigo).subscribe(
      (
        varPrecios: ProductoPrecio[]) => {

        varPrecios.forEach(element => {
          console.log(newValue);
          this.apiUnidad.getUnidad(element.idUnidad.toString()).subscribe(
            (
              varUni: Unidades[]) => {

              varUni.forEach(elementU => {
                console.log(newValue);
                if (this.emisor.preciosIva === 'S' && this.tipoCompra === 'F' && produc.iva === 'S') {
                  let valor = this.emisor.iva.toString().replace('0', '1');
                  produc.valorUnitario = element.precioVenta / Number.parseFloat(valor);

                } else {
                  produc.valorUnitario = element.precioVenta;
                }

                this.productoSelecionado = produc;
                this.productoSelecionado.factor = elementU.factor;
                this.productoSelecionado.idUnidad = element.idUnidad;
                this.productoSelecionado.total =
                  this.productoSelecionado.cantidad *
                  this.productoSelecionado.valorUnitario;
                this.calcular();

              });
            }
            , err => {
              console.log(err);

            });

        });


      }
      , err => {
        console.log(err);

      });

  }


   RecaculcularIvaPorItem(newValue, produc: Producto, empresa:Emisor,compra) {
    this.apiProducto.buscarProductoPrecioUnidadProducto(newValue, produc.codigo).subscribe(
      (
        varPrecios: ProductoPrecio[]) => {

        varPrecios.forEach(element => {
          console.log(newValue);
          this.apiUnidad.getUnidad(element.idUnidad.toString()).subscribe(
            (
              varUni: Unidades[]) => {

              varUni.forEach(elementU => {
                console.log(newValue);
                if (empresa.preciosIva === 'S' && compra === 'F' && produc.iva === 'S') {
                  let valor = empresa.iva.toString().replace('0', '1');
                  produc.valorUnitario = element.precioVenta / Number.parseFloat(valor);

                } else {
                  produc.valorUnitario = element.precioVenta;
                }

                this.productoSelecionado = produc;
                this.productoSelecionado.factor = elementU.factor;
                this.productoSelecionado.idUnidad = element.idUnidad;
                this.productoSelecionado.total =
                  this.productoSelecionado.cantidad *
                  this.productoSelecionado.valorUnitario;
                this.calcular();

              });
            }
            , err => {
              console.log(err);

            });

        });


      }
      , err => {
        console.log(err);

      });

  }




  obtenerFila(prod: Producto) {
    this.buscarProducto(prod.codigoPrincipal.toString());
  }

  obtenerCliente(cli: Clientes) {
    this.clienteActual = cli;
    this.lgCliente.hide();
  }

  // Cierre




  valorTotalBilleteVeinte() {
    this.total_billete_veinte = 20 * this.billete_veinte;
    this.total_billete_veinte = this.redondear(this.total_billete_veinte);
  }

  valorTotalBilleteCincuenta() {
    this.total_billete_cincuenta = 50 * this.billete_cincuenta;
    this.total_billete_cincuenta = this.redondear(this.total_billete_cincuenta);
  }


  valorTotalBilleteCien() {
    this.total_billete_cien = 100 * this.billete_cien;
    this.total_billete_cien = this.redondear(this.total_billete_cien);
  }

  valorTotalBilleteCinco() {
    this.total_billete_cinco = 5 * this.billete_cinco;
    this.total_billete_cinco = this.redondear(this.total_billete_cinco);
  }

  valorTotalBilleteDiez() {
    this.total_billete_diez = 10 * this.billete_diez;
    this.total_billete_diez = this.redondear(this.total_billete_diez);
  }

  valorTotalBilleteUno() {
    this.total_billete_uno = 1 * this.billete_uno;
    this.total_billete_uno = this.redondear(this.total_billete_uno);
  }
  valorTotalMonedaUnDolar() {
    this.total_un_dolar = 1 * this.un_dolar;
    this.total_un_dolar = this.redondear(this.total_un_dolar);
  }


  valorTotalMonedaCincuenta() {
    this.total_cincuenta_centavo = 0.50 * this.cincuenta_centavo;
    this.total_cincuenta_centavo = this.redondear(this.total_cincuenta_centavo);
  }


  valorTotalGastos() {
    this.gastosTotal = this.redondear(this.gastos)
  }


  valorTotalApertura() {
    this.valorApertura = this.redondear(this.valorApertura)
    this.total_apertura = this.valorApertura
  }

  valorTotalMonedaCinco() {
    this.total_cinco_centavo = 0.05 * this.cinco_centavo;
    this.total_cinco_centavo = this.redondear(this.total_cinco_centavo);
  }
  valorTotalCentavos() {
    this.total_centavos = 0.01 * this.un_centavo;
    this.total_centavos = this.redondear(this.total_centavos);
  }
  valorTotalDiez() {
    this.total_diez_centavo = 0.10 * this.diez_centavo;
    this.total_diez_centavo = this.redondear(this.total_diez_centavo);
  }

  valorTotalVeinticinco() {
    this.total_veinticion_centavo = 0.25 * this.veinticion_centavo;
    this.total_veinticion_centavo = this.redondear(this.total_veinticion_centavo);
  }
  redondear(numero: number) {
    this.totalEfectivoCaja();
    return Math.round((numero + Number.EPSILON) * 100) / 100;
  }


  totalEfectivoCaja() {
    this.total_caja = this.total_centavos + this.total_cinco_centavo +
      this.total_diez_centavo + this.total_veinticion_centavo + this.total_cincuenta_centavo
      + this.total_un_dolar + this.total_billete_uno + this.total_billete_cinco + this.total_billete_diez + this.total_billete_veinte
      + this.total_billete_cincuenta + this.total_billete_cien;
    this.total_caja = this.redondearValor(this.total_caja);
    this.total_Ventas_Gastos = this.total_efectivo - this.gastos;

  }



  guardarCierre() {
    let total = this.redondearValor(this.total_efectivo) + this.redondearValor(this.total_apertura)
    this.total = this.redondearValor(this.total)
    this.total_caja = this.redondearValor(this.total_caja)
    this.total_Ventas_Gastos = this.redondearValor(this.total_Ventas_Gastos)
    // if (this.redondearValor(total) == this.redondearValor(this.total_caja)) {

    if (this.redondearValor(this.total_Ventas_Gastos) == this.redondearValor(this.total_caja)) {

      this.caja = new Caja()
      this.caja.caja = Number.parseInt(localStorage.getItem("caja"))
      this.caja.total = this.total_apertura;
      this.caja.totalCaja = this.total_caja
      this.caja.id = 0;
      this.caja.usuario = localStorage.getItem('usuario')
      this.caja.tarjeta = 0;
      this.caja.transferencia = this.total_transferencia
      this.caja.credito = this.total_credito
      this.caja.efectivo = this.total_efectivo
      this.caja.gastos = this.gastos
      this.caja.idEmisor = Number.parseInt(localStorage.getItem('id'))
      this.caja.estado = "C"
      this.caja.detalle = new cajaDetalle()
      this.caja.detalle.id = 0
      this.caja.detalle.modedaUno = this.billete_uno
      this.caja.detalle.modela5 = this.cinco_centavo
      this.caja.detalle.moneda10 = this.diez_centavo
      this.caja.detalle.moneda25 = this.veinticion_centavo
      this.caja.detalle.moneda50 = this.cincuenta_centavo
      this.caja.detalle.moneda_centavo = this.un_centavo
      this.caja.detalle.valorUnDolar = this.billete_uno
      this.caja.detalle.valorDolar5 = this.billete_cinco
      this.caja.detalle.valorDolar10 = this.billete_diez
      this.caja.detalle.valorDolar20 = this.billete_veinte
      this.caja.detalle.valorDolar50 = this.billete_cincuenta
      this.caja.detalle.valorDolar100 = this.billete_cien
      this.apiCaja.cerraCaja(this.caja).subscribe(

        data => {
          this.modalService.dismissAll();
          this.validarCajaCerrada();
          let url = environment.apiReportes + "cierre_ventas.rptdesign&__format=pdf&idEmisor=" + localStorage.getItem("id") + "&usuario=" + localStorage.getItem('usuario');
          const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
          this.alertService.success("Se actualizo con exito..");
        },

        error => {
          this.alertService.danger("Caja esta cerrada")
          this.alertService.danger(error)

        }

      );

    } else {
       // text: "Caja descuadrada total ventas dia $" + this.redondearValor(this.total_Ventas_Gastos) + " total cierre $" + this.redondearValor(this.total_caja),
     
      Swal.fire({
        title: "Alerta....",
        text: "Caja descuadrada",
        icon: "warning",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.caja = new Caja()
          this.caja.caja = Number.parseInt(localStorage.getItem("caja"))
          this.caja.total = this.total_apertura;
          this.caja.totalCaja = this.total_caja
          this.caja.id = 0;
          this.caja.usuario = localStorage.getItem('usuario')
          this.caja.tarjeta = 0;
          this.caja.transferencia = this.total_transferencia
          this.caja.credito = this.total_credito
          this.caja.efectivo = this.total_efectivo
          this.caja.gastos = this.gastos
          this.caja.idEmisor = Number.parseInt(localStorage.getItem('id'))
          this.caja.estado = "C"
          this.caja.detalle = new cajaDetalle()
          this.caja.detalle.id = 0
          this.caja.detalle.modedaUno = this.billete_uno
          this.caja.detalle.modela5 = this.cinco_centavo
          this.caja.detalle.moneda10 = this.diez_centavo
          this.caja.detalle.moneda25 = this.veinticion_centavo
          this.caja.detalle.moneda50 = this.cincuenta_centavo
          this.caja.detalle.moneda_centavo = this.un_centavo
          this.caja.detalle.valorUnDolar = this.billete_uno
          this.caja.detalle.valorDolar5 = this.billete_cinco
          this.caja.detalle.valorDolar10 = this.billete_diez
          this.caja.detalle.valorDolar20 = this.billete_veinte
          this.caja.detalle.valorDolar50 = this.billete_cincuenta
          this.caja.detalle.valorDolar100 = this.billete_cien
          this.apiCaja.cerraCaja(this.caja).subscribe(

            data => {
              this.modalService.dismissAll();
              this.validarCajaCerrada();
              let url = environment.apiReportes + "cierre_ventas.rptdesign&__format=pdf&idEmisor=" + localStorage.getItem("id") + "&usuario=" + localStorage.getItem('usuario');
              const WindowPrt = window.open(url, '', 'left=0,top=0,width=800,height=500,toolbar=0,scrollbars=0,status=0');
              this.alertService.success("Se actualizo con exito..");
            },

            error => {
              this.alertService.danger("Caja esta cerrada")
              this.alertService.danger(error)

            }

          );

        } else {

        }
      });
    }


  }

}